import { UnderDevelopment } from "@/shared/components";

function ContactPage() {
    return (
        <div className="basicWrapper">
            <UnderDevelopment featureName="Contact page" />
        </div>
    )
}

export default ContactPage;